import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import useSignUpHook from '../hooks/useSignUpHook';

const NewPasswordScreen = dynamic(() => import('./NewPasswordScreen'));
const NewUserScreen = dynamic(() => import('./NewUserScreen'));
const SMSScreen = dynamic(() => import('./SMSScreen'));

type Screens = {
  [key: string]: JSX.Element;
};

const SignupFlow = () => {
  const {
    identifiant,
    setIdentifiant,
    error,
    phone,
    setPhone,

    verificationCode,
    setVerificationCode,
    newPassword,
    setnewPassword,
    newRePassword,
    setnewRePassword,
    signupNewUser,
    sendOtpSms,
    VerifyOtpSms,
    verifyUserByPhone,
  } = useSignUpHook();
  const SCREENS: Screens = {
    'new-user': (
      <NewUserScreen
        identifiant={identifiant}
        setIdentifiant={setIdentifiant}
        phone={phone}
        setPhone={setPhone}
        onClickNext={verifyUserByPhone}
        error={error['new-user']}
      />
    ),
    sms: (
      <SMSScreen
        verifyCode={verificationCode}
        setVerifyCode={setVerificationCode}
        reSendVerificationCode={sendOtpSms}
        handleNextClick={VerifyOtpSms}
        error={error.sms}
      />
    ),
    'new-password': (
      <NewPasswordScreen
        password={newPassword}
        setPassword={setnewPassword}
        confirmPassword={newRePassword}
        setConfirmPassword={setnewRePassword}
        clickConnexion={signupNewUser}
        error={error['new-password']}
      />
    ),
  };
  const { query } = useRouter();
  const { screen } = query;
  const screenName = screen?.toString() || 'new-user';
  return <>{SCREENS[screenName]}</>;
};

export default SignupFlow;
